import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Services extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			SERVICE_NAME: '',
			SERVICE_DESC: ''
		};
		
		var serviceListInit = this.copyTable(serviceList);
		serviceListInit.query.search = this.constructSearch(search);

		this.state = {
			serviceList: serviceListInit,
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onSubmitSearch(event) {
		var newServiceList = this.copyTable(serviceList);
		newServiceList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			serviceList: newServiceList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: [
				{ Attribute: 'ACTIVE_SERVICE', Operator: '=', StringValue: 'Y' }
			]
		};

		if (!this.isEmpty(data.SERVICE_NAME)) search.Children.push({ Attribute: 'SERVICE_NAME', Operator: '=', StringValue: data.SERVICE_NAME });
		if (!this.isEmpty(data.SERVICE_DESC)) search.Children.push({ Attribute: 'SERVICE_DESC', Operator: '=', StringValue: data.SERVICE_DESC });

		return search;
	}
	
	addService() {
		this.props.navigate('/HeLAD/Services/new');
	}
	
	editService(serviceId) {
		this.props.setServiceEditable(true);
		this.props.navigate('/HeLAD/Services/' + serviceId);		
	}

	viewService(serviceId) {
		this.props.setServiceEditable(false);
		this.props.navigate('/HeLAD/Services/' + serviceId);		
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Services',
			columns: exportColumns,
			entity: 'LIQUID_AIR.SERVICES',
			search: this.constructSearch(this.state.search)
		});
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>Services</span>
						<ChemEdit parent={this} columns={serviceSearch} data={this.state.search} renderKey={this.state.renderKey} 
						  onChange={(accessor, value) => this.onChangeSearch(accessor, value)} {...this.props} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='HeLAD_Services' table={this.state.serviceList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='315px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const serviceSearch = [
	{ Header: 'Name', accessor: 'SERVICE_NAME', row: 0, col: 0 },
	{ Header: 'Description', accessor: 'SERVICE_DESC', row: 0, col: 1 }
];

const serviceList = {
	query: { entity: 'LIQUID_AIR.SERVICES', search: null },
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addService()} />, accessor: 'id', 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editService(props.row.values.SERVICE_ID)} />, width: 25 },
		{ Header: '', accessor: 'SERVICE_ID', show: false },
		{ Header: 'Service', accessor: 'SERVICE_NAME', width: 175,
			Cell: props => <HashLink onClick={() => props.parent.viewService(props.row.values.SERVICE_ID)}>{props.value}</HashLink> },
		{ Header: 'Description', accessor: 'SERVICE_DESC', width: 400 },
		{ Header: 'Price', accessor: 'SERVICE_PRICE', width: 70 }
	]
};

const exportColumns = [
	{ Header: 'Service', accessor: 'SERVICE_NAME', width: 35 },
	{ Header: 'Description', accessor: 'SERVICE_DESC', width: 80 },
	{ Header: 'Price', accessor: 'SERVICE_PRICE', width: 14 }
];

export default withRouter(Services);
